import { render } from "./HomeButtonBonus.vue?vue&type=template&id=7cb17800&scoped=true"
const script = {}

import "./HomeButtonBonus.vue?vue&type=style&index=0&id=7cb17800&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cb17800"]])

export default __exports__